<template>
  <div>
    <v-container>
      <v-card>
        <v-card-title>
          <v-row v-if="!vedorManagable">
            <v-alert border="top" color="red lighten-2" dark dismissible dense>
              کاربر گرامی، استفاده از این بخش نیازمند فعال سازی قابلیت مدیریت وندور می‌باشد. در
              صورت نیاز با واحد پشتیبانی تکصان تماس بگیرید
            </v-alert>
          </v-row>
        </v-card-title>

        <InformMessageList v-if="vedorManagable"
          :informGroupId="'1020'"
          :idChanged="informGroupIdChanged"
          :informGrouptitle="informGroupDetails?.name"
          :selectedInformGrroup="informGroupDetails"
        ></InformMessageList>
      </v-card>
    </v-container>
  </div>
</template>

<script>
//import CategoriesList from "../components/CategoriesList.vue";
import InformMessageList from '../components/InformMessageList.vue';
import { RepoFactory } from '@/baseRepository/Factory';
const notificationRepository = () => RepoFactory.get('notification');

import Helper from '@/core/helpers';
import qs from 'qs';
export default {
  components: {
    InformMessageList,
  },
  data() {
    return {
      informGroupIdChanged: false,
      informGroupId: null,
      showAddNewwGrpItemModal: false,
      showgrpInfoModal: false,
      loading: false,
      items: [],
      itemsPerPage: 10,
      pageNumber: 1,
      //select: {},
      pageCount: 0,
      informGroupDetails: null,
      categoryIds: [],
      UserIds: [],
      userRoles: [],
      merchantCategoriesListProps: [],
      merchantCategoryFields: [
        {
          value: 'mainCategoryTitle',
          text: 'نوع فعالیت',
          sortable: false,
        },
        {
          value: 'breadcrumb',
          text: 'فرایند اصلی',
          sortable: false,
        },

        // {
        //   value: "actions",
        //   text: "حذف",
        //   sortable: false,
        // },
      ],
      informMessagingTypes: [
        {
          title: 'AllUsers',
          displayName: 'همه کاربران',
        },
        {
          title: 'SpecifiedUserRoles',
          displayName: 'کاربران نقش‌های خاص',
        },
        {
          title: 'SpecifiedCategoryIds',
          displayName: 'فعالان حوزه‌های کسب و کار خاص',
        },
        {
          title: 'SpecifiedUsers',
          displayName: 'کاربران خاص',
        },
      ],
    };
  },
  created() {
    this.getInformGroupById('1020');
  },
  computed: {
    notificationBaseUrl() {
      return this.$store.getters.notificationBaseUrl;
    },
    vedorManagable() {
      return this.$store.getters.currentMerchantObject?.vendorManageable;
    },
  },
  methods: {
    getinformMessagingTypeTitle(type) {
      const item = this.informMessagingTypes.find((el) => el.title === type);
      if (item) {
        return item.displayName;
      }
      return '';
    },
    removeMerchantCategoriesList() {},
    closeModal(data) {
      //this.getInformGroups();
      this.showAddNewwGrpItemModal = data;
    },
    // getInformGroups(pageNumber = 1, itemsPerPage = 1000) {
    //   const loader = this.$loading.show();
    //   this.loading = true;
    //   let params = {
    //     PageNumber: pageNumber,
    //     ItemsPerPage: itemsPerPage,
    //   };
    //   params.Orders = [
    //     {
    //       column: "Id",
    //       order: "Descending",
    //     },
    //   ];

    //   notificationRepository()
    //     .getAllInformMessagingGroup(
    //       this.notificationBaseUrl,
    //       {},
    //       params,
    //       (params) => {
    //         return qs.stringify(params, { allowDots: true });
    //       }
    //     )
    //     .then((res) => {
    //       this.pageCount = Math.ceil(res.data.totalCount / itemsPerPage);
    //       this.items = res.data.list;
    //       this.loading = false;
    //       this.select = res.data.list[0];
    //       loader.hide();
    //     })
    //     .catch((error) => {
    //       this.loading = false;
    //       loader.hide();
    //       Helper.handleErrors(error, this);
    //     });
    // },
    getInformGroupById(grpId) {
      console.log('select', grpId);
      this.showgrpInfoModal = true;
      const loader = this.$loading.show();
      this.loading = true;
      this.categoryIds = [];
      this.merchantCategoriesListProps = [];
      notificationRepository()
        .getInformGroupById(this.notificationBaseUrl, {}, grpId)
        .then((res) => {
          console.log('res.data: informGroupDetails :', res.data);
          this.informGroupDetails = res.data;

          this.loading = false;
          loader.hide();
        })
        .catch((error) => {
          this.loading = false;
          loader.hide();
          Helper.handleErrors(error, this);
        });
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped></style>
